import { render, staticRenderFns } from "./App.vue?vue&type=template&id=25b1bc0c&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports